export const QUEUED_CALLS_PAGE_SIZE = 15;
export const WAITING_CALLS_LIST_ARGS = '"status":"waiting"';
export const ATTENTION_MS = 2000;
export const TICK_MS = 1000;
